var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail3C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 225,
    viewBox: "0 0 328 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 225,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 266.277,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 237.756,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 294.725,
    y: 9.45557,
    width: 23.7681,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 9.45557,
    width: 95.0725,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 21.1743,
    width: 308.986,
    height: 1.875,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 185.541,
    y: 9.45557,
    width: 47.5362,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 32.4243,
    width: 47.5362,
    height: 4.6875,
    fill: "#E0E0E0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 227.313,
    y: 46.4868,
    width: 91.1781,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 136.136,
    y: 46.4868,
    width: 91.1781,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 107.614,
    y: 46.4868,
    width: 28.5217,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0283,
    y: 46.4868,
    width: 69.5856,
    height: 7.58929,
    fill: "#EEEEEE",
    stroke: "#CCCCCC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 227.313,
    y: 54.0781,
    width: 91.1781,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 136.136,
    y: 54.0781,
    width: 91.1781,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 9.50684,
    y: 54.0784,
    width: 28.5217,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 107.614,
    y: 54.0781,
    width: 28.5217,
    height: 37.5,
    stroke: "#CCCCCC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0283,
    y: 54.0781,
    width: 69.5856,
    height: 37.5,
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail3C);
export default __webpack_public_path__ + "static/media/thumbnail-3-c.4621de1468ad0cb1b948101ba53576cd.svg";
export { ForwardRef as ReactComponent };